import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastsService {
  public toasts: any[] = [];

  public showSuccess(message: string) {
    this.show(message, {
      classname: 'bg-success text-light',
      delay: 10000
    });
  }

  public showError(message: string) {
    this.show(message, {
      classname: 'bg-danger text-light',
      delay: 10000
    });
  }

  public show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    let toast = { textOrTpl, ...options };

    this.toasts.push(toast);

    setTimeout(
      () => {
        this.remove(toast);
      }, options.delay || 5000);
  }

  public remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
